// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 20302-场馆经营时间查询 GET /app/v1/gym/businessTime/${param0} */
export async function getGymBusinessTime(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymBusinessTimeParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymBusinessTimeVo>(
    `/app/v1/gym/businessTime/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20308-教练列表 GET /app/v1/gym/coach/list/${param0} */
export async function getGymCoachList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymCoachListParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimCoachListVo>(
    `/app/v1/gym/coach/list/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20301-场馆详情查询 GET /app/v1/gym/detail/${param0} */
export async function getGymInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymInfoParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymDetailVo>(
    `/app/v1/gym/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20311-查询场馆最新运营消息 GET /app/v1/gym/latestOperationMessage/${param0} */
export async function getLatestOperationMessage(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getLatestOperationMessageParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymMessageVo>(
    `/app/v1/gym/latestOperationMessage/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20307-场馆公告详情查询 GET /app/v1/gym/notice/detail/${param0} */
export async function getNoticeDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getNoticeDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimNoticeBasicVo>(
    `/app/v1/gym/notice/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20306-场馆公告分页列表查询 POST /app/v1/gym/notice/pageList */
export async function getGymNoticePageList(
  body: API.SwimGymNoticePageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimGymNoticeListVo>(
    "/app/v1/gym/notice/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 20304-停车场详情 GET /app/v1/gym/parking/detail/${param0} */
export async function getParkingDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getParkingDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymParkingDetailVo>(
    `/app/v1/gym/parking/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20303-场馆停车场列表查询 GET /app/v1/gym/parking/list/${param0} */
export async function getGymParkingList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymParkingListParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimGymParkingListVo>(
    `/app/v1/gym/parking/list/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20309-泳池详情查询 GET /app/v1/gym/pool/detail/${param0} */
export async function getPoolDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPoolDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGymPoolDetailVo>(
    `/app/v1/gym/pool/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20305-场馆泳池列表查询 GET /app/v1/gym/pool/list/${param0} */
export async function getGymPoolList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymPoolListParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimGymPoolListVo>(
    `/app/v1/gym/pool/list/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 20310-场馆通知滚动消息 GET /app/v1/gym/scrollMessages/${param0} */
export async function getGymScrollMessages(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGymScrollMessagesParams,
  options?: { [key: string]: any }
) {
  const { gymId: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimGymMessageVo>(
    `/app/v1/gym/scrollMessages/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
